import React, { useEffect, useMemo, useRef, useState } from "react";
import classes from "../assets/styles/EditCardFunctions.module.css";
import FormInput from "../components/Forms/FormInput";
import baseURL from "../utils/constants/baseUrl";
import { IoShareSocial } from "react-icons/io5";
import { FiTrash2 } from "react-icons/fi";
import { BsImageFill } from "react-icons/bs";
import { AiOutlineClose } from "react-icons/ai";
import ImageUpload from "../components/ImageUpload";
import Joi from "joi";
import {
  CardBackGroundImages,
  Colors,
  AddMoreCustomUrls,
} from "../utils/data/CardFunctionsData";
import PhoneInput from "react-phone-input-2";
import { Button, Form, Modal } from "react-bootstrap";
import "react-phone-input-2/lib/material.css";
import { useDropzone } from "react-dropzone";
import { SketchPicker } from "react-color";
import _ from "lodash";
import { get, put } from "../server";
import { CONTACT } from "../utils/constants/apiUrl";
import { loggedInUser, teamIDCheck, subscribedPackage } from "../utils/store";
import { useAtom } from "jotai";
import { useParams, useNavigate, Link } from "react-router-dom";
import Loader from "../components/Loader";
import showToast from "../helpers/showToast";
import AddEditCardSchema from "../utils/SchemasValidation/AddEditCardSchema";
import ValidateSchema from "../helpers/ValidateSchema";
import uploadImage from "../helpers/uploadImage";
import { MdClose } from "react-icons/md";
import socialMediaLinksSchema from "../utils/SchemasValidation/ModalSocialMediaLinksSchema";
import { ReactComponent as PersonIcon } from "../assets/images/edit_card_contact_icons/person.svg";
import { ReactComponent as LocationIcon } from "../assets/images/edit_card_contact_icons/location.svg";
import { ReactComponent as BioIcon } from "../assets/images/edit_card_contact_icons/bio.svg";
import { ReactComponent as PhoneIcon } from "../assets/images/edit_card_contact_icons/phone.svg";
import { ReactComponent as WebsiteURLIcon } from "../assets/images/edit_card_contact_icons/website_url.svg";
import { ReactComponent as CompanyBuildingIcon } from "../assets/images/edit_card_contact_icons/company_building.svg";
import { ReactComponent as EmailIcon } from "../assets/images/edit_card_contact_icons/email.svg";
import { ReactComponent as BackgroundIcon } from "../assets/images/edit_card_contact_icons/background.svg";
import { formatUrl, validatePhoneWithCountryCode } from "../utils/functions";
import pictureicon from "../assets/images/function_page_icons/picIcon.svg";
import companylogo from "../assets/images/function_page_icons/companylogo.svg";
import crossicon from "../assets/images/global_icons/crossicon.svg";
import Select from "../components/Select";
import CropImageModal from "../components/Modals/CropImageModal";

import Card from "../components/PageComponents/Function/Card";

const EditContact = () => {
  const [contact, setContact] = useState({
    card_type: "",
    first_name: "",
    last_name: "",
    email: "",
    company: "",
    company_position: "",
    logo: "",
    background_image: "",
    profile_image: "",
    color: "",
    country_phone: "",
    phone_number: "",
    description: "",
    address: "",
    country: "",
    city: "",
    state: "",
    website_url: "",
    card_social_media: [],
    pronouns: "",
    contact_card_phone: [],
    team_id: null,
    content_view_type: null,
    profile_image_shape: null,
    logo_shape: null,
  });

  const [extraContactData, setExtraContactData] = useState({
    id: "",
    user_id: "",
    contact_type: "",
    contact_user_id: "",
    related_data_id: "",
  });

  const [value, setValue] = useState();
  const [errors, setErrors] = useState({});
  const [mediaLinkErrors, setMediaLinkErrors] = useState([]);

  const [loading, setLoading] = useState(false);
  const [mediaOpen, setMediaOpen] = useState(false);
  const [uploadImageOpen, setUploadImageOpen] = useState(false);
  const [colorPickerOpen, setColorPickerOpen] = useState(false);
  const [customMediaLinkOpen, setCustomMediaLinkOpen] = useState(false);

  const [modalMediaLinks, setModalMediaLinks] = useState([]);

  const [customColor, setCustomColor] = useState(false);
  const [customBackgroundImage, setCustomBackgroundImage] = useState(false);

  const [imageUploadKey, setImageUploadKey] = useState("");

  const [preview, setPreview] = useState(null);
  const [result, setResult] = useState(null);
  const [fileData, setFileData] = useState("");
  const [crop, setCrop] = useState();
  const [showModal, setShowModal] = useState(false);
  const [cropType, setCropType] = useState("");

  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [userTeamId, setUserTeamId] = useAtom(teamIDCheck);
  const [purchasedPackage, setPurchasedPackage] = useAtom(subscribedPackage);
  const [pronounCheckBox, setPronounCheckBox] = useState(false);

  const [customPronoun, setCustomPronoun] = useState("");

  const [customLabel, setCustomLabel] = useState([
    {
      index_no: "",
      label: "",
    },
  ]);

  const [customMediaLink, setCustomMediaLink] = useState("");
  const [customMediaLinkError, setCustomMediaLinkError] = useState({});
  const [notifyChanges, setNotifyChanges] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");

  const selectedStyleClass = contact.content_view_type || "listDesign"; // fallback

  const selectedShapeClass = contact.profile_image_shape || "circle"; // fallback

  const profileRef = useRef(null);
  const logoRef = useRef(null);

  const { id } = useParams();

  const navigate = useNavigate();

  const handleCloseModal = () => {
    setCrop();
    setShowModal(false);
  };

  useEffect(() => {
    if (result) {
      if (cropType == "profile") {
        setContact({ ...contact, profile_image: fileData });
      } else {
        setContact({ ...contact, logo: fileData });
      }

      setCropType("");
    }
  }, [result]);

  const handleCustomPronounChange = (e) => {
    setCustomPronoun(e.target.value);
  };

  const pronounsOptions = [
    { value: "she/her", label: "She/Her" },
    { value: "he/him", label: "He/Him" },
    { value: "they/them", label: "They/Them" },
    { value: "custom", label: "Custom" },
  ];

  // handle phone type input change
  const handlePhoneTypeChange = (e, index) => {
    const type = e.target.value;
    if (
      e.target.value === "custom" &&
      purchasedPackage &&
      purchasedPackage.id == 1
    ) {
      showToast(
        false,
        "The requested feature is not compatible with your current plan. Upgrade your plan to continue using these features"
      );
      return;
    }

    const newArray = contact.contact_card_phone.map((item, i) => {
      if (index === i) {
        // return { ...item, phone_type: e.target.value };
        return {
          ...item,
          phone_type: type,
          // keep extension only for work
          phone_extension: type === "work" ? item.phone_extension || "" : "",
        };
      } else {
        return item;
      }
    });
    setContact({
      ...contact,
      contact_card_phone: newArray,
    });
  };

  // handle phone type input change
  const handlePhoneNumberChange = (value, country, index) => {
    const newArray = contact.contact_card_phone.map((item, i) => {
      if (index === i) {
        return {
          ...item,
          phone_number: value,
          country_phone: `${country.dialCode}`,
        };
      } else {
        return item;
      }
    });
    setContact({
      ...contact,
      contact_card_phone: newArray,
    });
  };

  const handlePhoneExtensionChange = (e, index) => {
    const newArray = contact.contact_card_phone.map((item, i) => {
      if (i === index) {
        return {
          ...item,
          phone_extension: e.target.value,
        };
      }
      return item;
    });

    setContact({
      ...contact,
      contact_card_phone: newArray,
    });
  };

  const handleCustomLabel = (e, index) => {
    const newArray = contact.contact_card_phone.map((item, i) => {
      if (index === i) {
        return {
          ...item,
          custom_label: e.target.value,
        };
      } else {
        return item;
      }
    });

    setContact({
      ...contact,
      contact_card_phone: newArray,
    });
  };

  const addPhoneFormField = () => {
    setContact((prev) => ({
      ...prev,
      contact_card_phone: [
        ...prev.contact_card_phone,
        {
          phone_type: "",
          country_phone: "",
          phone_number: "",
          custom_label: "",
          phone_extension: "",
        },
      ],
    }));
  };

  const removePhoneFormField = (i) => {
    let removeContactPhone = [...contact.contact_card_phone];
    removeContactPhone.splice(i, 1);
    setContact({ ...contact, contact_card_phone: removeContactPhone });
    setErrors({});
  };
  // const filteredMediaLinks = useMemo(() => {
  //   const filteredLinks = _.cloneDeep(AddMoreCustomUrls);

  //   const newFilteredLinks = [];
  //   filteredLinks.forEach((item) => {
  //     const found = modalMediaLinks.find(
  //       (single) => single.media_type === item.name
  //     );

  //     if (!found || item.name === "custom") {
  //       newFilteredLinks.push(item);
  //     }
  //   });

  //   return newFilteredLinks;
  // }, [modalMediaLinks]);

  const filteredMediaLinks = useMemo(() => {
    const filteredLinks = _.cloneDeep(AddMoreCustomUrls);
    if (purchasedPackage.id === 1) {
      const newFilteredLinks = [];
      filteredLinks.forEach((item) => {
        const found = modalMediaLinks.find(
          (single) => single.media_type === item.name
        );
        if (!found || item.name === "custom") {
          newFilteredLinks.push(item);
        }
      });
      return newFilteredLinks;
    } else {
      return filteredLinks;
    }
  }, [modalMediaLinks]);

  useEffect(() => {
    fetchSingleContact();
  }, []);

  const fetchSingleContact = async () => {
    setLoading(true);
    let queryParams = "";

    if (userTeamId) {
      queryParams = `?team_id=${userTeamId}`;
    }
    let { status, message, data } = await get(
      `${CONTACT}/${id}${queryParams}`,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    if (status) {
      setExtraContactData({
        id: data.id,
        user_id: data.user_id,
        contact_type: data.contact_type,
        contact_user_id: data.contact_user_id,
        related_data_id: data.contactCard.id,
      });

      data = data.contactCard;

      let card_social_media = [];

      data.contact_card_social_media.forEach((item) => {
        let foundIcon = AddMoreCustomUrls.find(
          (single) =>
            single.name === item.media_type ||
            single.oldName === item.media_type
        );

        card_social_media.push({
          media_type: item.media_type,
          url: item.url,
          icon: item.media_type === "custom" ? "custom" : foundIcon?.icon,
          custom_label: item.custom_label,
        });
      });

      const bgFound = CardBackGroundImages.find(
        (item) => data.background_image == item.img
      );

      if (!bgFound) {
        setCustomBackgroundImage(true);
      }

      let newCardPhone = [];
      let newCustomLabels = [];
      data.contact_card_phone.forEach((singlePhone, index) => {
        const customOrNot = ["home", "office", "work"].includes(
          singlePhone.phone_type
        );

        newCardPhone.push({
          country_phone: singlePhone.country_phone,
          phone_number: singlePhone.phone_number
            ? `${singlePhone.country_phone ? singlePhone.country_phone : ""}${singlePhone.phone_number
            }`
            : "",
          phone_type: customOrNot ? singlePhone.phone_type : "custom",
          custom_label: customOrNot ? "" : singlePhone.phone_type,
          phone_extension: singlePhone.phone_extension || "",
        });
      });

      const customPronounsOrNot = [
        null,
        "",
        "she/her",
        "he/him",
        "they/them",
      ].includes(data.pronouns);

      if (!customPronounsOrNot) {
        setCustomPronoun(data.pronouns);
      } else {
        setCustomPronoun("");
      }

      if (data.pronouns) {
        setPronounCheckBox(true);
      }

      setContact({
        id: data.id,
        card_type: data.card_type,
        first_name: data.first_name ? data.first_name : "",
        last_name: data.last_name ? data.last_name : "",
        email: data.email ? data.email : "",
        company: data.company ? data.company : "",
        company_position: data.company_position ? data.company_position : "",
        logo: data.logo ? data.logo : "",
        background_image: data.background_image ? data.background_image : "",
        profile_image: data.profile_image ? data.profile_image : "",
        color: data.color ? data.color : "",
        country_phone: data.country_phone ? `${data.country_phone}` : "",
        phone_number: data.phone_number
          ? `${data.country_phone ? data.country_phone : ""}${data.phone_number
          }`
          : "",
        description: data.description ? data.description : "",
        address: data.address ? data.address : "",
        country: data.country ? data.country : "",
        city: data.city ? data.city : "",
        state: data.state ? data.state : "",
        website_url: data.website_url ? data.website_url : "",
        card_social_media: card_social_media,
        pronouns: customPronounsOrNot ? data.pronouns : "custom",
        contact_card_phone: newCardPhone,
        team_id: data.team_id ? data.team_id : null,
        content_view_type: data.content_view_type
          ? data.content_view_type
          : null,
        profile_image_shape: data.profile_image_shape
          ? data.profile_image_shape
          : null,
        logo_shape: data.logo_shape ? data.logo_shape : null,
      });
      setCustomLabel(newCustomLabels);
    } else {
      showToast(status, message);
    }

    setLoading(false);
  };

  const handleImageChange = (files) => {
    const selectedFile = files[0];
    const maxSizeInBytes = 10 * 1024 * 1024; // 10MB

    if (selectedFile.size > maxSizeInBytes) {
      showToast(
        false,
        "The selected image size exceeds the maximum limit of 10MB."
      );
      return;
    }

    setContact({ ...contact, [imageUploadKey]: selectedFile });

    if (imageUploadKey === "profile_image") {
      setPreview(URL.createObjectURL(selectedFile));
      setShowModal(true);
      setCropType("profile");
    }
    if (imageUploadKey === "logo") {
      setPreview(URL.createObjectURL(selectedFile));
      setShowModal(true);
      setCropType("logo");
    }

    if (imageUploadKey === "background_image") {
      setCustomBackgroundImage(true);
    }

    handleUploadImageClose();
  };

  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop: handleImageChange,
    accept: {
      "image/jpeg": [],
      "image/png": [],
    },
  });

  const handleMediaOpen = () => {
    setModalMediaLinks(_.cloneDeep(contact.card_social_media));
    setMediaOpen(true);
  };

  const handleMediaClose = () => {
    setModalMediaLinks([]);
    setMediaLinkErrors({});
    setMediaOpen(false);
  };

  const handleColorPickerOpen = () => setColorPickerOpen(true);

  const handleColorPickerClose = () => setColorPickerOpen(false);

  const handleUploadImageOpen = (key) => {
    if (
      key === "background_image" &&
      purchasedPackage &&
      purchasedPackage.id == 1
    ) {
      showToast(
        false,
        "The requested feature is not compatible with your current plan. Upgrade your plan to continue using these features"
      );
      return;
    }

    setUploadImageOpen(true);
    setImageUploadKey(key);
  };

  const handleUploadImageClose = () => {
    setUploadImageOpen(false);
    setImageUploadKey("");
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    if (
      name === "pronouns" &&
      value === "custom" &&
      purchasedPackage &&
      purchasedPackage.id == 1
    ) {
      setContact({ ...contact, pronouns: "" });
      showToast(
        false,
        "The requested feature is not compatible with your current plan. Upgrade your plan to continue using these features"
      );
      return;
    }

    setContact({ ...contact, [name]: value });
  };

  const handleMediaChange = (e) => {
    if (
      e.target.value === "custom" &&
      purchasedPackage &&
      purchasedPackage.id == 1
    ) {
      showToast(
        false,
        "The requested feature is not compatible with your current plan. Upgrade your plan to continue using these features"
      );
      return;
    }

    if (e.target.value === "custom") {
      setMediaOpen(false);
      setCustomMediaLinkOpen(true);
    }
    const found = AddMoreCustomUrls.find(
      (item) => item.name === e.target.value
    );

    let newSocialMediaLinks = _.cloneDeep(modalMediaLinks);

    newSocialMediaLinks.push({
      media_type: found.name,
      url: "",
      icon: found.name === "custom" ? "custom" : found.icon,
      custom_label: "",
    });

    setModalMediaLinks(newSocialMediaLinks);
  };

  const handleCustomMediaNameSave = () => {
    if (!validateCustomMediaLink()) return;
    let newSocialMediaLinks = _.cloneDeep(modalMediaLinks);

    newSocialMediaLinks[newSocialMediaLinks.length - 1].custom_label =
      customMediaLink;

    setModalMediaLinks(newSocialMediaLinks);
    setCustomMediaLinkOpen(false);
    setCustomMediaLink("");
    setMediaOpen(true);
  };

  const handleCustomMediaModalClose = () => {
    setCustomMediaLinkOpen(false);

    let newSocialMediaLinks = _.cloneDeep(modalMediaLinks);
    newSocialMediaLinks.splice(newSocialMediaLinks.length - 1, 1);
    setModalMediaLinks(newSocialMediaLinks);

    setMediaOpen(true);
  };

  const handleModalUrlChange = (e, index) => {
    let newSocialMediaLinks = _.cloneDeep(modalMediaLinks);

    newSocialMediaLinks[index].url = formatUrl(e.target.value);

    setModalMediaLinks(newSocialMediaLinks);
  };

  const handleMedialSave = () => {
    if (!validateMediaModalForm()) return;

    setContact({ ...contact, card_social_media: modalMediaLinks });
    handleMediaClose();
  };

  const handleModalMediaDelete = (index) => {
    let newSocialMediaLinks = _.cloneDeep(modalMediaLinks);
    newSocialMediaLinks.splice(index, 1);
    setModalMediaLinks(newSocialMediaLinks);
  };

  const validateForm = () => {
    let newErrors = ValidateSchema(contact, AddEditCardSchema);

    setErrors(newErrors);

    if (Object.keys(newErrors).length) return false;

    return true;
  };

  const validateMediaModalForm = () => {
    let newErrors = ValidateSchema(modalMediaLinks, socialMediaLinksSchema);

    setMediaLinkErrors(newErrors);

    if (Object.keys(newErrors).length) return false;

    return true;
  };

  const validateCustomMediaLink = () => {
    let newErrors = ValidateSchema(
      { customMediaLink },
      Joi.object({
        customMediaLink: Joi.string().max(50).required().messages({
          "string.empty": `Please enter Custom Media Name`,
          "string.max": `Custom Media Name must be maximum 50 characters!`,
        }),
      })
    );

    setCustomMediaLinkError(newErrors);

    if (Object.keys(newErrors).length) return false;

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    // Validate phone number
    setErrors({});
    if (contact.pronouns === "custom" && customPronoun.length > 20) {
      setErrors({
        custom_pronouns: "Custom pronouns can be max 20 characters long",
      });
      return;
    }

    for (let index = 0; index < contact.contact_card_phone.length; index++) {
      const data = contact.contact_card_phone[index];
      if (data.phone_type || data.phone_number) {
        if (data.phone_type === "") {
          setErrors({
            [`phone_number${index}`]: "Please select phone type",
          });
          return;
        }

        if (data.phone_number === "") {
          setErrors({
            [`phone_number${index}`]: "Please enter phone number",
          });
          return;
        }

        if (data.phone_number.length > data.country_phone.length) {
          let resultPhone = validatePhoneWithCountryCode(
            data.country_phone,
            data.phone_number
          );
          if (resultPhone) {
            setErrors({
              [`phone_number${index}`]: resultPhone,
            });
            return false;
          }
        }

        if (data.phone_type === "custom" && data.custom_label === "") {
          setErrors({
            [`lable${index}`]: "Please enter custom phone label",
          });
          return;
        }

        if (data.phone_type === "custom" && data.custom_label.length > 20) {
          setErrors({
            [`lable${index}`]: "Custom Label can be max 20 characters long",
          });
          return;
        }
      }
    }

    setLoading(true);

    let payload = _.cloneDeep(contact);

    // Handle website Url
    payload.website_url = formatUrl(payload.website_url);

    if (typeof payload.background_image == "object") {
      const { status, message, data } = await uploadImage(
        "card_background",
        payload.background_image,
        loggedUser?.token
      );

      if (status) {
        payload.background_image = data;
      } else {
        showToast(status, message);
        setLoading(false);
        return;
      }
    }

    if (typeof payload.profile_image == "object") {
      const { status, message, data } = await uploadImage(
        "card_profile",
        payload.profile_image,
        loggedUser?.token
      );

      if (status) {
        payload.profile_image = data;
      } else {
        showToast(status, message);
        setLoading(false);
        return;
      }
    }

    if (typeof payload.logo == "object" && payload.card_type === "business") {
      const { status, message, data } = await uploadImage(
        "card_logo",
        payload.logo,
        loggedUser?.token
      );

      if (status) {
        payload.logo = data;
      } else {
        showToast(status, message);
        setLoading(false);
        return;
      }
    }

    if (payload.card_type === "personal") {
      payload.logo = "";
    }

    payload.card_social_media.forEach((item) => {
      delete item.icon;
    });

    payload.contact_card_social_media = payload.card_social_media;
    delete payload.card_social_media;

    payload.id = extraContactData.related_data_id;
    payload.user_id = extraContactData.user_id;
    payload.contact_id = extraContactData.id;
    payload.contact_user_id = extraContactData.contact_user_id;

    if (payload.contact_card_phone.length > 0) {
      let cardPhoneArr = payload.contact_card_phone.map((item, index) => {
        if (item.phone_type === "custom") {
          return {
            ...item,
            phone_type: item.custom_label ? item.custom_label : "custom",
            phone_number: item.phone_number.slice(
              item.country_phone.length,
              item.phone_number.length
            ),
          };
        } else {
          return {
            ...item,
            phone_number: item.phone_number.slice(
              item.country_phone.length,
              item.phone_number.length
            ),
          };
        }
      });

      cardPhoneArr.forEach((object) => {
        delete object["custom_label"];
      });

      cardPhoneArr = cardPhoneArr.filter(function (el) {
        return el.phone_number != "";
      });

      payload.contact_card_phone = cardPhoneArr;
    }

    if (payload.pronouns === "custom") {
      payload.pronouns = customPronoun;
    }

    if (payload.pronouns === "custom" && customPronoun === "") {
      payload.pronouns = "";
    }

    let final_payload = {
      contact_type: extraContactData.contact_type,
      related_data: payload,
    };
    if (notifyChanges) {
      payload.is_notify_users = 1;
      payload.notification_message = notificationMessage;
    } else {
      payload.is_notify_users = 0;
      payload.notification_message = "";
    }

    let { status, message, data } = await put(
      `${CONTACT}/${id}`,
      final_payload,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    if (status) {
      navigate("/contacts");
    }

    showToast(status, message);

    setLoading(false);
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <div className="outerWrapper1">
        <div className="col-md-8 col-12">
          <div className="row mainWrapper heading">
            <h1 className="">
              <Link to="/contacts" className="function-link">
                Connections
              </Link>
              {` > Edit Connection`}
            </h1>
          </div>

          <div className="mainWrapper-card p-4">
            <div className="row">
              <div className="col-md-6 col-12">
                <div className="row mb-2">
                  <span className="imageHeaderLabel">Your Photo</span>
                </div>

                <div className="row align-items-center">
                  <div className="col-4">
                    <ImageUpload
                      imageLink={true}
                      imageUrl={contact.profile_image}
                      width="72px"
                      height="72px"
                      enableClick={false}
                      dummyImage={pictureicon}
                    />
                  </div>

                  <div className="col-8">
                    <Button
                      variant="primary"
                      className="uploadBtn"
                      // onClick={() => profileRef.current.click()}
                      onClick={() => handleUploadImageOpen("profile_image")}
                    >
                      Upload New
                    </Button>
                    <input
                      accept="image/*"
                      type="file"
                      name="profile_image"
                      ref={profileRef}
                      style={{ display: "none" }}
                      onChange={(e) =>
                        setContact({
                          ...contact,
                          profile_image: e.target.files[0],
                        })
                      }
                    />
                    <button
                      className="removeImgBtn"
                      onClick={() =>
                        setContact({ ...contact, profile_image: "" })
                      }
                    >
                      Remove Profile Picture
                    </button>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-12">
                {contact.card_type === "business" ? (
                  <>
                    <div className="row mb-2">
                      <span className="imageHeaderLabel">Logo</span>
                    </div>

                    <div className="row">
                      <div className="col-4">
                        <ImageUpload
                          imageLink={true}
                          imageUrl={contact.logo}
                          width="72px"
                          height="72px"
                          enableClick={false}
                          dummyImage={companylogo}
                        />
                      </div>

                      <div className="col-8 align-items-center">
                        <button
                          className="uploadBtn"
                          // onClick={() => logoRef.current.click()}
                          onClick={() => handleUploadImageOpen("logo")}
                        >
                          Upload New
                        </button>
                        <input
                          accept="image/*"
                          type="file"
                          name="logo"
                          ref={logoRef}
                          style={{ display: "none" }}
                          onChange={(e) =>
                            setContact({ ...contact, logo: e.target.files[0] })
                          }
                        />
                        <button
                          className="removeImgBtn"
                          onClick={() => setContact({ ...contact, logo: "" })}
                        >
                          Remove Company Logo
                        </button>
                      </div>
                    </div>
                  </>
                ) : null}
              </div>
            </div>

            {/* <hr className="divider" /> */}

            <div className="row mt-4">
              <div className="col-12">
                <div className="colorWrapper">
                  {Colors.map((color) => {
                    const { id, bgColor } = { ...color };
                    return (
                      <div
                        key={`color${id}`}
                        style={{ backgroundColor: bgColor }}
                        className={`colorDiv ${contact.color == bgColor
                            ? "selectedColorOption"
                            : null
                          }`}
                        onClick={() =>
                          setContact({ ...contact, color: bgColor })
                        }
                      />
                    );
                  })}
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="sectionHeader">
                  <div className="sectionIconHeader">
                    <BackgroundIcon />
                  </div>
                  <span>Background</span>
                </div>
                <div className="backgroundWrapper">
                  {CardBackGroundImages.map((image) => {
                    const { id, img } = { ...image };
                    return (
                      <img
                        key={`backgroundImage${id}`}
                        src={`${baseURL.PUBLIC_URL}${img}`}
                        alt=""
                        className={
                          contact.background_image == img
                            ? "selectedOption"
                            : null
                        }
                        onClick={() => {
                          if (!customBackgroundImage) {
                            setContact({
                              ...contact,
                              background_image: img,
                            });
                          }
                        }}
                      />
                    );
                  })}
                  {contact.background_image && customBackgroundImage ? (
                    <div className="customBackgroundWrapper">
                      <img
                        src={
                          contact.background_image
                            ? typeof contact.background_image === "object"
                              ? `${URL.createObjectURL(
                                contact.background_image
                              )}`
                              : `${baseURL.PUBLIC_URL}${contact.background_image}`
                            : ""
                        }
                        alt=""
                        className="selectedOption"
                      />
                      <div className="bgImgClearBtnWrapper">
                        <MdClose
                          className="bgImgClearBtn"
                          onClick={() => {
                            setContact({
                              ...contact,
                              background_image: CardBackGroundImages[0].img,
                            });
                            setCustomBackgroundImage(false);
                          }}
                        />
                      </div>
                    </div>
                  ) : (
                    <div
                      className="emptyBackgroundImage"
                      onClick={() => handleUploadImageOpen("background_image")}
                    >
                      <span>+</span>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 col-12">
                <div className="mb-4">
                  <div className="sectionHeader">
                    <div className="sectionIconHeader">
                      <PersonIcon />
                    </div>
                    <span>Full Name</span>
                  </div>
                  <FormInput
                    type="text"
                    name="first_name"
                    placeholder="First name"
                    value={contact.first_name}
                    handleChange={handleChange}
                    error={errors.first_name}
                  />
                  <FormInput
                    type="text"
                    name="last_name"
                    placeholder="Last name"
                    value={contact.last_name}
                    handleChange={handleChange}
                    error={errors.last_name}
                  />
                </div>

                <div className="mb-4">
                  <div>
                    <div
                      className="sectionHeader"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <div className="sectionIconHeader">
                          <PersonIcon />
                        </div>
                        <span>Pronouns</span>
                      </div>
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          name="pronoun_check"
                          checked={pronounCheckBox}
                          onChange={(e) => {
                            setPronounCheckBox(e.target.checked);

                            if (!e.target.checked) {
                              setContact({
                                ...contact,
                                pronouns: "",
                              });
                              setCustomPronoun("");
                            }
                          }}
                        />
                      </div>
                    </div>

                    <div style={{ marginBottom: "10px" }}>
                      <Select
                        placeholder="Choose your pronouns"
                        options={pronounsOptions}
                        value={contact.pronouns}
                        name="pronouns"
                        disabled={!pronounCheckBox}
                        onChange={handleChange}
                      />
                    </div>
                    {contact.pronouns === "custom" && (
                      <>
                        <div
                          className={
                            errors.custom_pronouns
                              ? "input-group globalInputWithIcon errorInput"
                              : "input-group  globalInputWithIcon"
                          }
                          style={{
                            marginTop: "10px",
                            marginBottom: "10px",
                          }}
                        >
                          <input
                            placeholder="Please Enter Custom Pronoun"
                            className={
                              errors.custom_pronouns
                                ? "form-control inputError"
                                : "form-control"
                            }
                            value={customPronoun}
                            onChange={handleCustomPronounChange}
                          />
                        </div>
                        <p className="errorText">
                          {errors.custom_pronouns || ""}
                        </p>
                      </>
                    )}
                  </div>
                </div>

                <div className="mb-4">
                  <div className="sectionHeader form-group">
                    <div className="sectionIconHeader">
                      <BioIcon />
                    </div>
                    <span>About me</span>
                  </div>
                  <textarea
                    // className={classes.textareaInput}
                    className={
                      errors.description
                        ? "globalTextArea errorInput form-control"
                        : "globalTextArea form-control"
                    }
                    type="text"
                    placeholder="Description"
                    name="description"
                    value={contact.description}
                    onChange={handleChange}
                  ></textarea>
                </div>

                <div className="mb-4">
                  <div className="sectionHeader">
                    <div className="sectionIconHeader">
                      <PhoneIcon />
                    </div>
                    <span>Contact Number 11</span>
                  </div>
                  <div style={{ maxWidth: "387px" }}>
                    {contact.contact_card_phone &&
                      contact.contact_card_phone?.map((element, index) => {
                        return (
                          <div
                            key={index}
                            className="contactPhoneInputOuterWrapper"
                          >
                            <div
                              className={`d-flex align-items-center gap-1 phoneInputMainWrapper`}
                            >
                              <div
                                className={`d-flex align-items-start flex-column `}
                              >
                                <div
                                  className={`d-flex align-items-center ${errors[`phone_number${index}`]
                                      ? "phoneInputWrapper errorInput"
                                      : "phoneInputWrapper "
                                    } phoneInputMainWrapper`}
                                >
                                  <div
                                    className="input-group globalInputWithIcon addCardSelect"
                                    style={{ maxWidth: "100px" }}
                                  >
                                    <select
                                      className="form-select customSelect"
                                      onChange={(e) =>
                                        handlePhoneTypeChange(e, index)
                                      }
                                      value={element.phone_type}
                                    >
                                      <option value="">Select</option>
                                      <option value="home">Home</option>
                                      <option value="office">Mobile</option>
                                      <option value="work">Work</option>
                                      <option value="custom">Custom</option>
                                    </select>
                                  </div>
                                  <div className="addPhoneInput">
                                    <PhoneInput
                                      country={"us"}
                                      enableSearch={true}
                                      countryCodeEditable={false}
                                      inputClass={
                                        errors[`phone_number${index}`]
                                          ? "phoneNumberInput errorInput"
                                          : "phoneNumberInput "
                                      }
                                      value={element.phone_number}
                                      onChange={(value, country) =>
                                        handlePhoneNumberChange(
                                          value,
                                          country,
                                          index
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                {element.phone_type === "work" && (
                                  <div className="formInputWrapper">
                                    <FormInput
                                      type="text"
                                      name={`phone_extension${index}`}
                                      placeholder="Enter Phone Extension"
                                      value={element.phone_extension || ""}
                                      handleChange={(e) =>
                                        handlePhoneExtensionChange(e, index)
                                      }
                                    />
                                  </div>
                                )}
                              </div>
                              <div className="removePhonutBtnWrapper">
                                <button
                                  onClick={() => removePhoneFormField(index)}
                                >
                                  <FiTrash2 />
                                </button>
                              </div>
                            </div>
                            <p className="errorText">
                              {errors[`phone_number${index}`]}
                            </p>
                            {element.phone_type === "custom" && (
                              <div
                                className="formInputWrapper"
                                style={{ marginTop: "0px" }}
                              >
                                <label
                                  className="inputLabel"
                                  style={{ fontSize: "14px" }}
                                >
                                  Custom Label
                                </label>
                                <FormInput
                                  name={errors[`lable${index}`]}
                                  placeholder={`Enter Phone Label`}
                                  value={element.custom_label}
                                  onChange={(e) => handleCustomLabel(e, index)}
                                  error={errors[`lable${index}`]}
                                />
                              </div>
                            )}
                          </div>
                        );
                      })}

                    <div>
                      <div className="addPhonutBtnWrapper">
                        <button onClick={() => addPhoneFormField()}>
                          Add Phone
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-12">
                {contact.card_type === "business" ? (
                  <div className="mb-4">
                    <div className="sectionHeader">
                      <div className="sectionIconHeader">
                        <CompanyBuildingIcon />
                      </div>
                      <span>Company & Job Position</span>
                    </div>
                    <FormInput
                      type="text"
                      name="company"
                      placeholder="Company name"
                      value={contact.company}
                      handleChange={handleChange}
                      error={errors.company}
                    />
                    <FormInput
                      type="text"
                      name="company_position"
                      placeholder="Position name"
                      value={contact.company_position}
                      handleChange={handleChange}
                      error={errors.company_position}
                    />
                  </div>
                ) : null}

                <div className="mb-4">
                  <div className="sectionHeader">
                    <div className="sectionIconHeader">
                      <EmailIcon />
                    </div>
                    <span>Email Address</span>
                  </div>
                  <FormInput
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={contact.email}
                    handleChange={handleChange}
                    error={errors.email}
                  />
                </div>

                <div className="mb-4">
                  <div className="sectionHeader">
                    <div className="sectionIconHeader">
                      <WebsiteURLIcon />
                    </div>
                    <span>Website</span>
                  </div>
                  <FormInput
                    type="text"
                    name="website_url"
                    placeholder="Url"
                    value={contact.website_url}
                    handleChange={handleChange}
                  />
                </div>
                <div className="mb-4">
                  <div className="sectionHeader">
                    <div className="sectionIconHeader">
                      <LocationIcon />
                    </div>
                    <span>Location</span>
                  </div>
                  <FormInput
                    type="text"
                    name="address"
                    placeholder="Address"
                    value={contact.address}
                    handleChange={handleChange}
                    error={errors.address}
                  />
                  <FormInput
                    type="text"
                    name="city"
                    placeholder="City"
                    value={contact.city}
                    handleChange={handleChange}
                    error={errors.city}
                  />
                  <FormInput
                    type="text"
                    name="state"
                    placeholder="State"
                    value={contact.state}
                    handleChange={handleChange}
                    error={errors.state}
                  />
                  <FormInput
                    type="text"
                    name="country"
                    placeholder="Country"
                    value={contact.country}
                    handleChange={handleChange}
                    error={errors.country}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="sectionHeader">
                  <IoShareSocial />
                  <span>Social Media</span>
                </div>
                <div className="socialMediaWrapper">
                  {contact.card_social_media.map((single, index) => (
                    <div
                      key={`socialMediaLink${index}`}
                      className="addedSocialLinks"
                    >
                      {single.icon === "custom"
                        ? single.custom_label.charAt(0)
                        : single.icon}
                    </div>
                  ))}
                  <div onClick={handleMediaOpen} className="addMoreSocialLinks">
                    +
                  </div>
                </div>
              </div>
            </div>
            {contact.card_type === "business" ? (
              <div className="row">
                <div className="col-12">
                  <div style={{ maxWidth: "387px" }}>
                    <div className="mb-4 ms-1">
                      <Form.Check
                        type="checkbox"
                        label="Notify user for changes"
                        checked={notifyChanges}
                        onChange={(e) => setNotifyChanges(e.target.checked)}
                      />
                    </div>
                    <div className="form-group mb-4">
                      <div className="sectionHeader">
                        <div className="sectionIconHeader">
                          <BioIcon />
                        </div>
                        <span>Notification Message</span>
                      </div>
                      <textarea
                        // className={classes.textareaInput}
                        className={
                          errors.description
                            ? "globalTextArea errorInput form-control"
                            : "globalTextArea form-control"
                        }
                        type="text"
                        placeholder="Message"
                        name="description"
                        // value={cardFunction.description}
                        // onChange={handleChange}
                        value={notificationMessage}
                        onChange={(e) => setNotificationMessage(e.target.value)}
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="row">
              <div className="col-12">
                <div className="submitBtnWrapper">
                  <Button variant="primary" onClick={handleSubmit}>
                    Submit
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="col-md-4 col-12">
          <Card data={cardFunction} />
        </div> */}
        <div className="col-md-4 col-12 cardView">
          <div className="card-views heading">
            <div>
              <Card
                data={{
                  ...contact,
                  pronouns:
                    contact.pronouns === "custom"
                      ? customPronoun
                      : contact.pronouns,
                }}
                content_view_type={selectedStyleClass}
                profile_image_shape={selectedShapeClass}
              />
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={customMediaLinkOpen}
        onHide={handleCustomMediaModalClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className={`customModal`}
        size="sm"
      >
        <Modal.Header className="mediaModalHeader">
          <span>Custom Media Link Name</span>
          <img
            src={crossicon}
            alt=""
            style={{ cursor: "pointer" }}
            onClick={handleCustomMediaModalClose}
          />
          {/* <GrClose onClick={handleUploadImageClose} /> */}
        </Modal.Header>

        <Modal.Body className="mediaModalBody">
          <FormInput
            type="text"
            placeholder="Custom Link Name"
            value={customMediaLink}
            handleChange={(e) => setCustomMediaLink(e.target.value)}
            error={customMediaLinkError.customMediaLink}
          />
        </Modal.Body>

        <Modal.Footer className="mediaModalFooter">
          <button onClick={handleCustomMediaNameSave}>Confirm</button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={mediaOpen}
        onHide={handleMediaClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className={`customModal`}
        size="sm"
      >
        <Modal.Header className="mediaModalHeader">
          <span>Social Links</span>
          <img
            src={crossicon}
            alt=""
            style={{ cursor: "pointer" }}
            onClick={handleMediaClose}
          />
          {/* <GrClose onClick={handleMediaClose} /> */}
        </Modal.Header>

        <Modal.Body className="mediaModalBody">
          <p>
            Add your social links that will be visible on the homepage of your
            blog.
          </p>

          {/* <select
            className={classes.select}
            value=""
            onChange={handleMediaChange}
          >
            <option value="" selected disabled>
              Add Social Link
            </option>
            {filteredMediaLinks.map((single, index) => (
              <option value={single.name} key={`mediaOption${index}`}>
                {single.name}
              </option>
            ))}
          </select> */}
          <div className="mt-4">
            <Select
              placeholder="Add Social Link"
              options={filteredMediaLinks}
              onChange={(e) => {
                handleMediaChange(e);
              }}
              labelKey="name"
              valueKey="name"
            />
          </div>

          {modalMediaLinks.map((single, index) => (
            <>
              <div
                className="socialMediaModalLink d-flex"
                key={`cardModalLink${index}`}
                style={
                  mediaLinkErrors[`${index}.url`]
                    ? { borderColor: "#e35252" }
                    : null
                }
              >
                <div className="socialMediaModalLinkIcon">
                  {single.icon === "custom"
                    ? single.custom_label.charAt(0)
                    : single.icon}
                </div>
                <input
                  defaultValue={single.url}
                  placeholder="Url"
                  onChange={(e) => handleModalUrlChange(e, index)}
                ></input>
                <FiTrash2
                  onClick={() => handleModalMediaDelete(index)}
                  className="socialLinkDeleteIcon"
                />
              </div>
              {mediaLinkErrors[`${index}.url`] ? (
                <div style={{ textAlign: "start" }}>
                  <span className="errorText">
                    {mediaLinkErrors[`${index}.url`]}
                  </span>
                </div>
              ) : null}
            </>
          ))}
        </Modal.Body>

        <Modal.Footer className="mediaModalFooter">
          <Button variant="primary" onClick={handleMedialSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={uploadImageOpen}
        onHide={handleUploadImageClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className={`customModal`}
        size="sm"
      >
        <Modal.Header className="mediaModalHeader">
          <span>Upload</span>
          <AiOutlineClose onClick={handleUploadImageClose} />
        </Modal.Header>

        <Modal.Body className="mediaModalBody">
          <div {...getRootProps()}>
            <input {...getInputProps()} />
            <div
              className={`d-flex justify-content-center align-items-center flex-column imageUpload`}
            >
              <BsImageFill />
              <span>
                Drop your Images here, or <span>Browse</span>
              </span>
              <span>Support JPG, PNG, Only</span>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={colorPickerOpen}
        onHide={handleColorPickerClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className={`customModal`}
        size="sm"
      >
        <Modal.Header className="mediaModalHeader">
          <span>Color Picker</span>
          <AiOutlineClose onClick={handleColorPickerClose} />
        </Modal.Header>

        <Modal.Body className={`d-flex justify-content-center mediaModalBody`}>
          <SketchPicker
            color={contact.color}
            onChangeComplete={(color) => {
              setContact({ ...contact, color: color.hex });
              setCustomColor(true);
            }}
          />
        </Modal.Body>
      </Modal>
      <style type="text/css">
        {`
        
        .phoneNumberInput {
          font-size: 14px !important;
        }
        .addPhoneInput .react-tel-input .form-control{
          padding: 18.5px 5px 18.5px 52px;
          border: 0 !important;
          width:100%;
        }

        .react-tel-input .selected-flag{
          padding: 0 0 0 12px;
        }
        .customSelect.form-select{
          padding: 9px 14px;

        }
        .phoneInputWrapper{
            border: 2px solid #DAE9F4;
            border-radius: 25px;
        }
        .phoneInputWrapper.errorInput {
          border: 2px solid #e35252 !important;
        }
        .phoneInputWrapper:focus-within {
          border: 2px solid #DAE9F4;
        }
        .addCardSelect.globalInputWithIcon{
          border: 0 !important;
          border-radius: 0;
          border-right: 2px solid #DAE9F4 !important;
        }

        .gridDesign .contactInfoInner {
          display: flex;
          flex-wrap: wrap;
          justify-content:space-between;
        }
        .gridDesign .infoContnt {
          width: 48%;
          flex: 0 0 auto;
          padding: 0.5rem;
          display: block;
          text-align: center;
          background:#fff;
          border-radius: 5px;
        }
        .gridDesign .infoContnt a{
          // white-space:normal;
          // display: inline-flex;
          word-break: break-word;
        }
        .gridDesign .contactInfo h6{
          width:100%;
        }
        .gridDesign .moreInfoIcon{
          max-width:38px;
          max-height:38px;
          margin:0 0 10px;
        }
        .treeDesign .contactInfoInner{position:relative;padding-left:15px}
        .treeDesign .contactInfoInner:before{
          content:"";
          border-left: 1px solid #B2B2B2;
          height: 100%;
          position: absolute;
          top: 10px;
          left: 0px;
        }
        .treeDesign .contactInfoInner h6, .treeDesign .contactInfoInner .infoContnt{
          position:relative;
        }
        .treeDesign .contactInfoInner h6:before{
          content:"";
          width: 15px;
          position: absolute;
          left: -15px;
          top: 0px;
          bottom: 0;
          height: 1px;
          margin: auto;
          background-color: #B2B2B2;
        }
        .treeDesign .contactInfoInner .infoContnt:before{
          content:"";
          width: 15px;
          position: absolute;
          height: 1px;
          background-color: #B2B2B2;
          left: -15px;
          top: 0;
          bottom: 0;
          margin: auto;
        }
        .treeDesign .contactInfoInner .infoContnt:after{
          content:"";
          width: 5px;
          height: 5px;
          background-color: #B2B2B2;
          border-radius: 50%;
          position: absolute;
          left: -2.4%;
        }
        .iconDesign .contactInfoInner{
          display:flex;
          flex-wrap:wrap;
        }
        .iconDesign .contactInfo h6{
          width:100%;
        }
        .iconDesign .contactInfoInner .infoContnt{
          width:30.33333%;
          flex: 0 0 auto;
          margin-right:3%;
        }
        .iconDesign .contactInfoInner .infoContnt .moreInfoIcon{
          display:none;
        }
        .iconDesign .contactInfoInner .infoContnt .subHeading{
          display:none;
        }
        .profileImg.circle div,
        .profileImg.circle img {
          border-radius: 50%;
          transition: 0.5s all ease;
        }
        .profileImg.square div,
        .profileImg.square img {
          border-radius: 2px;
          transition: 0.5s all ease;
        }
        .profileImg.rectangular div,
        .profileImg.rectangular img {
          border-radius: 2px;
          width: 90px;
          height: 65px;
          transition: 0.5s all ease;
        }
        .logoWrapper.circle div,
          .logoWrapper.circle img {
            border-radius: 50%;
            transition: 0.5s all ease;
          }
          .logoWrapper.square div,
          .logoWrapper.square img {
            border-radius: 2px;
            transition: 0.5s all ease;
          }
          .logoWrapper.rectangular div,
          .logoWrapper.rectangular img {
            border-radius: 2px;
            width: 50px;
            height: 25px;
            transition: 0.5s all ease;
          }
	`}
      </style>

      {preview && (
        <CropImageModal
          show={showModal}
          image={preview}
          handleCloseModal={handleCloseModal}
          result={result}
          setResult={setResult}
          setFileData={setFileData}
          crop={crop}
          setCrop={setCrop}
        />
      )}
    </>
  );
};

export default EditContact;
